import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layouts from "../../config/layouts/Layouts";
import NavbarComponent from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";

const FACT_KEYS = [
    "nombre",
    "razonSocial",
    "constitucion",
    "base",
    "fundador",
    "posicionamiento",
    "especializacion",
    "contacto",
];

const AREA_LINKS = [
    ["ia", "/servicios/inteligencia-artificial"],
    ["software", "/servicios/software-y-aplicaciones"],
    ["ciber", "/servicios/ciberseguridad"],
    ["aviacion", "/ia-aviacion-seguridad-operacional"],
];

export default function About() {
    const { t } = useTranslation();

    return (
        <Layouts>
            <header><NavbarComponent /></header>
            <main className="min-h-screen bg-em-bg pb-[calc(7rem+var(--em-footer-h))] pt-32 text-em-text sm:pt-36 md:pt-40">
                <div className="mx-auto max-w-5xl px-5 md:px-8">
                    <p className="text-xs font-bold uppercase tracking-[0.2em] text-em-accent">{t("about.eyebrow")}</p>
                    <h1 className="mt-4 max-w-4xl text-4xl font-black tracking-tight md:text-6xl">
                        {t("about.title")}
                    </h1>
                    <p className="mt-7 max-w-3xl text-lg leading-8 text-em-soft md:text-xl">
                        {t("about.lead")}
                    </p>

                    <section className="mt-14 grid gap-8 md:grid-cols-[1.1fr_0.9fr]">
                        <div className="rounded-3xl border border-em-text/10 bg-em-card p-7 md:p-9">
                            <h2 className="text-2xl font-extrabold">{t("about.diffTitle")}</h2>
                            <p className="mt-4 leading-7 text-em-soft">
                                {t("about.diffP1")}
                            </p>
                            <p className="mt-4 leading-7 text-em-soft">
                                {t("about.diffP2")}
                            </p>
                        </div>
                        <dl className="overflow-hidden rounded-3xl border border-em-text/10 bg-em-bg">
                            {FACT_KEYS.map((key) => (
                                <div key={key} className="border-b border-em-text/10 p-5 last:border-0">
                                    <dt className="text-xs font-bold uppercase tracking-wider text-em-muted">{t(`about.facts.${key}.term`)}</dt>
                                    <dd className="mt-1 font-semibold text-em-text">{t(`about.facts.${key}.detail`)}</dd>
                                </div>
                            ))}
                            <div className="p-5">
                                <dt className="text-xs font-bold uppercase tracking-wider text-em-muted">{t("about.verifTitle")}</dt>
                                <dd className="mt-2">
                                    <a
                                        className="font-semibold text-em-accent hover:text-em-accent2"
                                        href="https://bibliotecadigital.ccb.org.co/server/api/core/bitstreams/88634c24-59aa-45fe-84c6-8414610c21d2/content"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {t("about.verifLink")} ↗
                                    </a>
                                </dd>
                            </div>
                        </dl>
                    </section>

                    <section className="mt-14">
                        <h2 className="text-3xl font-black">{t("about.areasTitle")}</h2>
                        <div className="mt-7 grid gap-4 sm:grid-cols-2">
                            {AREA_LINKS.map(([key, to]) => (
                                <Link key={to} to={to} className="rounded-2xl border border-em-text/10 bg-em-card p-6 text-lg font-bold transition hover:-translate-y-1 hover:border-em-accent/40 hover:text-em-accent">
                                    {t(`about.areas.${key}`)} <span aria-hidden>→</span>
                                </Link>
                            ))}
                        </div>
                    </section>
                </div>
            </main>
            <Footer />
        </Layouts>
    );
}
